import React from "react";
import "./HelpTooltip.css";

/**
 * HelpTooltip Component
 * 
 * Displays a circular question mark icon that shows a tooltip on hover.
 * Useful for providing contextual help throughout the application.
 * 
 * @param {string} text - The tooltip text to display on hover
 * @param {string} position - Tooltip position: "top", "bottom", "left", "right" (default: "top")
 * @param {string} className - Additional CSS classes to apply
 */
export const HelpTooltip = ({ text, position = "top", className = "" }) => {
  return (
    <div className={`help-tooltip-wrapper ${position} ${className}`} role="tooltip" aria-label={text}>
      <span className="help-icon">?</span>
      <div className="help-tooltip-box">
        {text}
      </div>
    </div>
  );
};

export default HelpTooltip;
